import { getShortFileName } from "../../../libs/generalFunctions";

import { IoDocumentAttach } from "react-icons/io5";
import { FaTrash } from "react-icons/fa";

import "./showUploadedAttach.scss";

function ShowUploadedAttach({ filesArr , setFilesArr }) {

//====Event handler start here====
const hanleDeleteFile = ( index )=>{   
  let newArr = [...filesArr];
    
  newArr.splice(index, 1);
  
  setFilesArr( [...newArr] );
  }

//====Event handler end here====

  return (
    <div className="showUploadedAttach" >
        {
         filesArr.map(( item , index )=>(
            <div className="item" key={ index } >
              <div className="item_name_and_deleteIcon">
                <FaTrash className="item_icon icon_trash" onClick={()=>{ hanleDeleteFile( index ) }}/>
                <span className="item_name" >{ item?.name && getShortFileName( item?.name ) }</span>
              </div>
             <IoDocumentAttach className="item_icon"/>
            </div>
         ))   
        }

    </div>
  )
}

export default ShowUploadedAttach